import { useTranslation } from 'react-i18next';

const Pricing = () => {
    const { t } = useTranslation();

    const pricingOptions = [
        {
            title: t('pricing.plans.existing.title'),
            description: t('pricing.plans.existing.description'),
            price: t('pricing.plans.existing.price'),
            period: t('pricing.plans.existing.period')
        },
        {
            title: t('pricing.plans.standard.title'),
            description: t('pricing.plans.standard.description'),
            price: t('pricing.plans.standard.price'),
            period: t('pricing.plans.standard.period')
        },
        {
            title: t('pricing.plans.rental.title'),
            description: t('pricing.plans.rental.description'),
            price: t('pricing.plans.rental.price'),
            period: t('pricing.plans.rental.period')
        }
    ];

    return (
        <div className="py-35 max-w-[940px] mx-auto" id="cenik">
            <h2 className="text-3xl font-bold text-center mb-15">
                {t('pricing.title')} <span className="text-primary">{t('pricing.highlight')}</span>
            </h2>

            <div className="flex flex-col gap-2.5">
                {pricingOptions.map((option, index) => (
                    <div
                        key={index}
                        className="bg-[#f6f7f1] rounded-[20px] p-10 grid grid-cols-1 md:grid-cols-4 justify-between items-center"
                    >
                        <div className='md:col-span-3'>
                            <h3 className="text-[28px] font-medium">{option.title}</h3>
                            {option.description && (
                                <p className="text-[#6d628a] mt-2" dangerouslySetInnerHTML={{ __html: option.description }} />
                            )}
                        </div>
                        <div className="text-right col-span-1">
                            <p className="text-2xl font-bold">{option.price}</p>
                            <p className="text-[#6d628a]">{option.period}</p>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Pricing;
